import { render } from "./ManufacturerTyreBrands.vue?vue&type=template&id=106e6631"
import script from "./ManufacturerTyreBrands.vue?vue&type=script&lang=js"
export * from "./ManufacturerTyreBrands.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__